module.exports = __webpack_public_path__ + "img/trainingClassData.4e1da329.svg";